import type { ReactNode } from "react";

interface Props {
  open: boolean;
  onToggle: () => void;
  children?: ReactNode;
}

// Gold-bordered persistent entry point into the volunteers panel inside
// the gap modal. Tapping toggles the inline volunteers/shortlist content.
export default function VolunteersButton({ open, onToggle, children }: Props) {
  return (
    <div className="volunteers-section">
      <button
        type="button"
        className={`volunteers-trigger ${open ? "is-open" : ""}`}
        onClick={onToggle}
        aria-expanded={open}
      >
        <PersonIcon />
        <span>Volunteers</span>
      </button>
      {open && children ? (
        <div className="volunteers-section__body">{children}</div>
      ) : null}
    </div>
  );
}

function PersonIcon() {
  return (
    <svg
      className="volunteers-trigger__icon"
      viewBox="0 0 16 16"
      width="18"
      height="18"
      aria-hidden="true"
    >
      <circle cx="8" cy="5" r="2.6" fill="currentColor" />
      <path
        d="M2.7 14 a5.3 5.3 0 0 1 10.6 0 z"
        fill="currentColor"
      />
    </svg>
  );
}
